import { GridContainer, GridItem } from "./HomeStyle";
import ContentCard from "./ContentCard";
import PlayIcon from "icons/PlayIcon";
import floatingIcon from "assets/icons/chatIconSecondary.svg";
import trashIcon from "assets/icons/trash.svg";
import { useHistory } from "react-router-dom";
import { TutorialContext } from "contexts/TutorialContext";
import { useContext, useEffect } from "react";
import { connect } from "react-redux";
import { generateHMAC } from "utils/utils";

const HelperSection = ({ user }) => {
  const history = useHistory();
  const { handleWatchVideo } = useContext(TutorialContext);
  const hmac = generateHMAC(user?.email, process.env.REACT_APP_INTERCOM_KEY);

  window.intercomSettings = {
    api_base: "https://api-iam.intercom.io",
    app_id: "vu0ufjy6",
    custom_launcher_selector: ".support-tour",
    hide_default_launcher: true,
  };

  useEffect(() => {
    window.Intercom("boot", {
      app_id: "vu0ufjy6",
      name: user?.full_name,
      email: JSON.stringify(user?.email),
      user_hash: hmac,
    });
  }, [user, hmac]);

  const helperData = [
    {
      header: "Schedule content",
      content: "Schedule posts to multiple channels with one click.",
      buttons: [
        {
          text: "Schedule post",
          onClick: () => history.push("/dashboard/posts/calendar-view?post_action=create_post"),
        },
      ],
    },
    {
      header: "Need help?",
      content:
        "Are you having troubles using a feature or finding you way around?",
      bg: "#EBF6FF",
      titleColor: "#032250",
      floatingIcon,
      buttons: [
        {
          text: "Watch tutorial",
          onClick: handleWatchVideo,
          className: "tutorialBtn",
          buttonIcon: <PlayIcon color="#FF6436" />,
        },
        {
          text: "Contact support",
          onClick: () => {},
          className: "secondaryBtn support-tour",
        },
      ],
    },
  ];

  return (
    <GridItem colSpan="3">
      <GridContainer columns="1fr 1fr" gap="24px">
        {helperData.map((data, index) => (
          <ContentCard key={index} {...data} />
        ))}
      </GridContainer>
    </GridItem>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(HelperSection);
